<script lang="ts">
  import {auth} from '$lib/stores/Auth.svelte';
  import { onMount } from 'svelte';
  import { ordersStore, loadFirst, loadMore } from '$lib/stores/Orders.svelte';
  import { maybeRefresh, logout } from '$lib/stores/Auth.svelte';
  import { localizeHref } from "$lib/paraglide/runtime";
</script>



<!-- login/logout button -->

<div class="flex justify-end mb-4">
  {#if auth.accessToken}
    <button onclick={logout} class="text-blue-500 hover:underline">
      Logout
    </button>
  {:else}
    <a href={localizeHref("/account/login")} class="text-blue-500 hover:underline">Login</a>
  {/if}
</div>